import authRoutes from "@/modules/auth/routes";
import infographicRoutes from "@/modules/infographic/routes";
import MonitoringRoutes from "@/modules/monitoring/routes";
import { IRoute } from "@/types";

const AppRoutes: IRoute[] = [
  ...authRoutes,
  ...infographicRoutes,
  ...MonitoringRoutes,
];

export default AppRoutes;
